import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgInstagram = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M12.006 2.981c2.942 0 3.29.013 4.447.065 1.075.047 1.655.227 2.043.378.511.198.881.438 1.264.82.387.388.623.753.821 1.264.15.387.331.972.378 2.042.052 1.16.065 1.508.065 4.444 0 2.94-.013 3.287-.065 4.443-.047 1.075-.227 1.655-.378 2.042a3.4 3.4 0 0 1-.821 1.263 3.4 3.4 0 0 1-1.265.821c-.387.15-.971.331-2.042.378-1.161.052-1.51.065-4.447.065-2.941 0-3.29-.013-4.446-.065-1.075-.047-1.656-.227-2.043-.378a3.4 3.4 0 0 1-1.264-.82 3.4 3.4 0 0 1-.821-1.264c-.15-.387-.331-.971-.379-2.042-.051-1.16-.064-1.508-.064-4.443 0-2.94.013-3.288.064-4.444.048-1.075.228-1.655.379-2.042.198-.511.438-.88.821-1.263a3.4 3.4 0 0 1 1.264-.821c.387-.15.972-.331 2.043-.378 1.157-.052 1.505-.065 4.446-.065m0-1.981c-2.988 0-3.362.013-4.536.064-1.17.052-1.974.241-2.67.512a5.4 5.4 0 0 0-1.953 1.272 5.4 5.4 0 0 0-1.273 1.947c-.27.7-.46 1.5-.512 2.669C1.011 8.64.998 9.015.998 12.002s.013 3.361.064 4.534c.052 1.17.241 1.973.512 2.67a5.4 5.4 0 0 0 1.273 1.95 5.4 5.4 0 0 0 1.948 1.268c.7.27 1.5.46 2.67.512 1.174.051 1.548.064 4.537.064s3.363-.013 4.537-.064c1.17-.052 1.974-.241 2.67-.512a5.4 5.4 0 0 0 1.948-1.268c.61-.61.99-1.225 1.269-1.947.27-.7.46-1.5.512-2.668.051-1.174.064-1.548.064-4.535s-.013-3.36-.064-4.534c-.052-1.169-.241-1.972-.512-2.669a5.15 5.15 0 0 0-1.26-1.955 5.4 5.4 0 0 0-1.948-1.268c-.701-.27-1.5-.46-2.67-.511C15.368 1.013 14.994 1 12.005 1'
    />
    <path
      fill={props.color}
      d='M12.006 6.35a5.655 5.655 0 0 0-5.654 5.652 5.655 5.655 0 0 0 11.31 0 5.655 5.655 0 0 0-5.656-5.651m0 9.318a3.67 3.67 0 0 1-3.668-3.666 3.668 3.668 0 0 1 7.337 0 3.67 3.67 0 0 1-3.669 3.666M19.205 6.127a1.32 1.32 0 1 1-2.64-.001 1.32 1.32 0 0 1 2.64.001'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgInstagram)
export default ForwardRef
